import { ClientInfo } from '../context/client_context'
import { CoinInfo } from '../context/coin_context'
import { NationalityEnum } from '../context/supplier_context'
import { ListReturn } from '../utils/maks'
import { get, post, put } from './generic'

export class ClientEmailAlreadyInUseError extends Error {
    constructor() {
        super()
    }
}

export class ClientDocumentAlreadyInUseError extends Error {
    constructor() {
        super()
    }
}

export interface CreateClientInterface {
    nome: string
    numero_documento: string
    email: string[] | null
    flag_ativo: number
    flag_fiado: number
    juros_credito_dia: number
    endereco: {
        nome: string
        flag_nacionalidade: number
        codigo_postal: string | null
        numero: string | null
    }
    phones: { telefone: string }[]
    valor_credito: number
    taxa_juros: number
    flag_cobrar_juros: number
    preco_preferivel: number | null
    flag_tipo_vencimento: number
    flag_tipo_documento: number
    flag_orgao_publico: number
    cpf_cnpj: string | null
    pais_nacionalidade: string
    path_documento: string | null
    flag_regime_isento_imposto: number
    data_limite_regime_isento_imposto: string | null
    path_documento_verso: string | null
    path_documento_regime_isento_imposto: string | null
    regime_empresa: string | null
    cod_departamento_emissao_empresa: string | null
    desc_departamento_emissao_empresa: string | null
    cod_cidade_emissao_empresa: string | null
    desc_cidade_emissao_empresa: string | null
    cod_atividade_economica_empresa: string | null
    desc_atividade_economica_empresa: string | null
    cod_distrito_emissao_empresa: string | null
    desc_distrito_emissao_empresa: string | null
    num_casa_emissao_empresa: string | null
    flag_exibir_dados_nota_remissao: number
    flag_fatura_exportacao: number
observacao: string | null
    informacoes_adicionais: string | null
    id_moeda: number
    id_funcionario?: number | null
}

export interface UpdateClientInterface extends Partial<CreateClientInterface> {
    id_cliente: number
}

export interface ListClientsInterface {
    skip: number
    take: number
    search?: string
    dontCount?: boolean
}

export interface GenerateClientExtractsInterface {
    id: number
    data_inicial: string | null
    data_final: string | null
    id_filial: number[]
    status: number[] | null
    fieldsToShow: any
    selectedFilters: Record<string, string>
}

export interface ClientApiData {
    dias_credito: number | null
    valor_credito: string | null
    credito_gasto: string | null
    emails: {
        email: string
    }[]
    flag_ativo: number
    flag_fiado: number
    id_cliente: number
    juros_credito_dia: number
    nome: string
    numero_documento: string
    endereco: {
        flag_nacionalidade: number
        id_endereco_cliente: number
        nome: string
        codigo_postal: string | null
        numero: string | null
    }
    telefones: {
        id_cliente: number
        id_telefone_cliente: number
        telefone: string
    }[]
    taxa_juros: string
    flag_cobrar_juros: number
    preco_preferivel: number | null
    flag_tipo_vencimento: number
    flag_tipo_documento: number
    flag_orgao_publico: number
    cpf_cnpj: string | null
    pais_nacionalidade: string
    path_documento: string | null
    credito_extra: string
    flag_regime_isento_imposto: number
    data_limite_regime_isento_imposto: string | null
    path_documento_verso: string | null
    path_documento_regime_isento_imposto: string | null
    regime_empresa: string | null
    cod_departamento_emissao_empresa: string | null
    desc_departamento_emissao_empresa: string | null
    cod_cidade_emissao_empresa: string | null
    desc_cidade_emissao_empresa: string | null
    cod_atividade_economica_empresa: string | null
    desc_atividade_economica_empresa: string | null
    cod_distrito_emissao_empresa: string | null
    desc_distrito_emissao_empresa: string | null
    num_casa_emissao_empresa: string | null
    flag_exibir_dados_nota_remissao: number
    flag_fatura_exportacao: number
observacao: string | null
    informacoes_adicionais: string | null
    id_moeda: number
    id_funcionario: number | null
}

export interface GenerateClientsBalanceInterface {
    order?: 'balance' | 'name'
    id_filial_master?: number
    status?: number[]
    includeClient: boolean
    includeSupplier: boolean
    showOnlyDebt: boolean
    fieldsToShow: Record<string, boolean>
}

export function parseClient(data: ClientApiData, coins?: CoinInfo[]): ClientInfo {
    return {
        name: data.nome,
        document: data.numero_documento,
        address: data.endereco ? data.endereco.nome : '',
        allowCredit: Boolean(data.flag_fiado),
        creditDays: data.juros_credito_dia.toString(),
        creditValue: data.valor_credito ? Number(data.valor_credito) : 0,
        emails: data.emails?.length ? data.emails.map((e) => e.email) : [''],
        nationality:
            data.endereco && data.endereco.flag_nacionalidade === 1
                ? NationalityEnum.Native
                : NationalityEnum.Foregein,
        phoneNumbers: data.telefones?.length
            ? data.telefones.map((telefone) => telefone.telefone)
            : [''],
        id: data.id_cliente,
        creditUsed: data.credito_gasto ? Number(data.credito_gasto) : 0,
        isActive: Boolean(data.flag_ativo),
        fees: Number(data.taxa_juros) * 100,
        chargeFees: Boolean(data.flag_cobrar_juros),
        prefferedPrice: data.preco_preferivel,
        expirationType: data.flag_tipo_vencimento,
        documentType: data.flag_tipo_documento,
        isPublicOrgan: Boolean(data.flag_orgao_publico),
        cpfCnpj: data.cpf_cnpj,
        nacionality: data.pais_nacionalidade,
        zipCode: data.endereco?.codigo_postal ?? '',
        number: data.endereco?.numero ?? '',
        image: data.path_documento
            ? {
                  content: data.path_documento,
                  file: new File([], data.path_documento),
                  isBase64: false,
              }
            : null,
        extraCredit: Number(data.credito_extra),
        taxFreeRegimen: Boolean(data.flag_regime_isento_imposto),
        taxFreeRegimenLimitDate: data.data_limite_regime_isento_imposto
            ? new Date(`${data.data_limite_regime_isento_imposto} 23:59:59`)
            : null,
        imageBack: data.path_documento_verso
            ? {
                  content: data.path_documento_verso,
                  file: new File([], data.path_documento_verso),
                  isBase64: false,
              }
            : null,
        taxFreeRegimenImage: data.path_documento_regime_isento_imposto
            ? {
                  content: data.path_documento_regime_isento_imposto,
                  file: new File([], data.path_documento_regime_isento_imposto),
                  isBase64: false,
              }
            : null,
        companyRegime: data.regime_empresa ?? '',
        companyEmissionDepartmentId:
            data.cod_departamento_emissao_empresa ?? '',
        companyEmissionDepartmentDescription:
            data.desc_departamento_emissao_empresa ?? '',
        companyEmissionCityId: data.cod_cidade_emissao_empresa ?? '',
        companyEmissionCityDescription: data.desc_cidade_emissao_empresa ?? '',
        companyEconomicActivityId: data.cod_atividade_economica_empresa ?? '',
        companyEconomicActivityDescription:
            data.desc_atividade_economica_empresa ?? '',
        companyEmissionHouseNumber: data.num_casa_emissao_empresa ?? '',
        companyEmissionDistrictId: data.cod_distrito_emissao_empresa ?? '',
        companyEmissionDistrictDescription:
            data.desc_distrito_emissao_empresa ?? '',
        showRemissionNoteData: Boolean(data.flag_exibir_dados_nota_remissao),
        faturaExportacao: Boolean(data.flag_fatura_exportacao),
        observation: data.observacao,
        informacoesAdicionais: data.informacoes_adicionais ?? null,
        employeeId: data.id_funcionario ?? null,
        coin: coins?.find(c => c.id === data.id_moeda),
    }
}

export async function createClient(
    infos: CreateClientInterface
): Promise<number> {
    try {
        const res = await post('client', infos, {
            useRecaptcha: true,
        })
        return res.data.data.client.id_cliente
    } catch (error: any) {
        if (error.message.includes('email already exists'))
            throw new ClientEmailAlreadyInUseError()
        if (error.message.includes('document already exists'))
            throw new ClientDocumentAlreadyInUseError()
        throw error
    }
}

export async function updateClient(
    infos: UpdateClientInterface
): Promise<void> {
    try {
        await put('client', infos, {
            useRecaptcha: true,
        })
    } catch (error: any) {
        if (error.message.includes('email already exists'))
            throw new ClientEmailAlreadyInUseError()
        if (error.message.includes('document already exists'))
            throw new ClientDocumentAlreadyInUseError()
        throw error
    }
}

export async function getClientById(clientId: number, coins: CoinInfo[]): Promise<ClientInfo> {
    const res = await post('client/specific', { id: clientId })
    return parseClient(res.data.data, coins)
}

export async function listClients(
    data: ListClientsInterface,
    coins: CoinInfo[]
): Promise<ListReturn<ClientInfo>> {
    const res = await post('clients', data)
    return {
        data: res.data.data.data.map((data: ClientApiData) =>
            parseClient(data, coins)
        ),
        count: res.data.data.count,
    }
}

export async function generateClientExtract(
    data: GenerateClientExtractsInterface
): Promise<void> {
    await post(
        `client/extract/${data.id}`,
        {
            ...data,
            id: undefined,
        },
        {
            useRecaptcha: true,
        }
    )
}

export async function exportClients(): Promise<void> {
    await post(
        'clients/export',
        {},
        {
            useRecaptcha: true,
        }
    )
}

export async function generateClientsBalance(
    data: GenerateClientsBalanceInterface
): Promise<void> {
    await post('client/balance', data, {
        useRecaptcha: true,
    })
}

export async function deleteClients(clients: number[]): Promise<void> {
    await post(
        'client/delete',
        { clients },
        {
            useRecaptcha: true,
        }
    )
}

export async function consultRuc(ruc: string): Promise<string | null> {
    try {
        const res = await get(`client/consult/${ruc}`, {
            useRecaptcha: true,
        })
        return res.data.data.name
    } catch (error) {
        return null
    }
}

export async function loadClientsFromExcel(
    base64Excel: string
): Promise<void> {
    await post(
        'client/load-clients-from-excel',
        { base64Excel },
        {
            useRecaptcha: true,
        }
    )
}
